module.exports = __webpack_public_path__ + "static/media/hand_phone.48588b25.png";